import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPageSeo } from "../lib/seo.cjs";

function upsertMeta(attr, key, content) {
  const matches = [...document.head.querySelectorAll(`meta[${attr}="${key}"]`)];
  let el = matches.shift();
  matches.forEach((duplicate) => duplicate.remove());
  if (content == null) { el?.remove(); return; }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  const matches = [...document.head.querySelectorAll(`link[rel="${rel}"]`)];
  let el = matches.shift();
  matches.forEach((duplicate) => duplicate.remove());
  if (!href) { el?.remove(); return; }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getPageSeo(pathname);
    document.title = seo.title;
    upsertMeta("name", "description", seo.description);
    upsertMeta("name", "robots", seo.robots);
    upsertMeta("property", "og:title", seo.title);
    upsertMeta("property", "og:description", seo.description);
    upsertMeta("property", "og:url", seo.canonical);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "HAQILA");
    upsertMeta("property", "og:locale", "en_US");
    upsertMeta("property", "og:image", seo.image?.url);
    upsertMeta("property", "og:image:alt", seo.image?.alt);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", seo.title);
    upsertMeta("name", "twitter:description", seo.description);
    upsertMeta("name", "twitter:image", seo.image?.url);
    upsertMeta("name", "twitter:image:alt", seo.image?.alt);
    upsertLink("canonical", seo.canonical);

    document.getElementById("page-jsonld")?.remove();
    let script = document.getElementById("site-jsonld");
    if (seo.jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "site-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(seo.jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [pathname]);

  return null;
}
